/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div :class="{'cursor-drag' : draggingCard === true}" class="vx-row ">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="inline-block wordBank">
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Sales PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Sales PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/server-5.png" width="20">
                <span class="ml-2">Sales Server</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Layer 3 Switch</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Layer 2 Switch</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Router</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/network1.png" width="20">
                <span class="ml-2">HR VLAN 22</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/network1.png" width="20">
                <span class="ml-2">HR VLAN 22</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/network1.png" width="20">
                <span class="ml-2">Finance VLAN 22</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">HR PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">HR PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Finance PC</span>
              </h5>
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation ">
                <img src="https://rapidsimulations.com/simulations/2/images/tower-pc.png" width="20">
                <span class="ml-2">Finance PC</span>
              </h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base p-4">
            <div class="vx-row mb-4">
              <div class="vx-col w-1/4">
                <div class="border-2 border-solid rounded">
                  <div class="flex items-center justify-center p-5">
                    <img class="mr-2" width="75" src="https://rapidsimulations.com/simulations/2/images/Omnidirectional.png">
                    <h1 class="font-bold ml-2">AP1</h1>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/4">
                <div class="border-2 border-solid rounded">
                  <div class="flex items-center justify-center p-5">
                    <img class="mr-2" width="75" src="https://rapidsimulations.com/simulations/2/images/Omnidirectional.png">
                    <h1 class="font-bold ml-2">AP2</h1>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/4">
                <div class="border-2 border-solid rounded">
                  <div class="flex items-center justify-center p-5">
                    <img class="mr-2" width="75" src="https://rapidsimulations.com/simulations/2/images/Omnidirectional.png">
                    <h1 class="font-bold ml-2">AP3</h1>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/4">
                <div class="border-2 border-solid rounded">
                  <div class="flex items-center justify-center p-5">
                    <img class="mr-2" width="75" src="https://cdn.discordapp.com/attachments/895123043750391808/895124242969010176/imageedit_2_9022788673.png">
                    <h4 class="font-bold ml-2">192.168.1.2<br>Speed: Auto<br>Duplex: Auto</h4>
                  </div>
                </div>
              </div>
            </div>
            <img src="https://rapidsimulations.com/simulations/2/images/New-Office-p-1600.png" class="responsive">
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>

</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      }


    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel()
        }
      }
    },
    markSimulation () {

      let total_score = 0


      if (document.getElementById('input0').textContent  === 'HR VLAN 22') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').textContent  === 'Layer 2 Switch') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').textContent  === 'HR VLAN 22') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else  {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }


      if (document.getElementById('input3').textContent  === 'HR PC') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input4').textContent  === 'HR PC') {
        document.getElementById('input4').style.borderColor = '#28C76F'
        document.getElementById('input4').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input4').style.borderColor = '#fd4445'
        document.getElementById('input4').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input5').textContent  === 'Finance VLAN 22') {
        document.getElementById('input5').style.borderColor = '#28C76F'
        document.getElementById('input5').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input5').style.borderColor = '#fd4445'
        document.getElementById('input5').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input6').textContent  === 'Finance PC') {
        document.getElementById('input6').style.borderColor = '#28C76F'
        document.getElementById('input6').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input6').style.borderColor = '#fd4445'
        document.getElementById('input6').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input7').textContent  === 'Finance PC') {
        document.getElementById('input7').style.borderColor = '#28C76F'
        document.getElementById('input7').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input7').style.borderColor = '#fd4445'
        document.getElementById('input7').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input8').textContent  === 'Router') {
        document.getElementById('input8').style.borderColor = '#28C76F'
        document.getElementById('input8').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input8').style.borderColor = '#fd4445'
        document.getElementById('input8').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input9').textContent  === 'Layer 3 Switch') {
        document.getElementById('input9').style.borderColor = '#28C76F'
        document.getElementById('input9').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input9').style.borderColor = '#fd4445'
        document.getElementById('input9').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input10').textContent  === 'Sales Server') {
        document.getElementById('input10').style.borderColor = '#28C76F'
        document.getElementById('input10').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input10').style.borderColor = '#fd4445'
        document.getElementById('input10').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input11').textContent  === 'Sales PC') {
        document.getElementById('input11').style.borderColor = '#28C76F'
        document.getElementById('input11').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input11').style.borderColor = '#fd4445'
        document.getElementById('input11').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input12').textContent  === 'Sales PC') {
        document.getElementById('input12').style.borderColor = '#28C76F'
        document.getElementById('input12').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input12').style.borderColor = '#fd4445'
        document.getElementById('input12').style.backgroundColor = '#fd4445'
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }
      this.$emit('simulation_getting_there', total_score)

    }
  },
  components: {
    draggable,
    Prism,
    vSelect

  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>
